// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clear-all-selected--t_7Wd{color:#96a0b4;font-size:22px !important}.clear-all-selected--t_7Wd:hover{color:#5a6272 !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clear-all-selected": "clear-all-selected--t_7Wd"
};
export default ___CSS_LOADER_EXPORT___;
